import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const ACC_AUDITS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('ACC_AUDITS');
export const ACC_AUDITS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	ACC_AUDITS_CRUD_ACTION_CONSTANTS
);
